import { useCallback } from "react";

import useClient from "hooks/useClient";

const useFindParkingGuideByContractId = (): {
  findParkingGuide: (contractId: string) => Promise<Attachment>;
} => {
  const { client } = useClient();

  const findParkingGuide = useCallback(
    async (contractId: string) => {
      const { data } = await client<Attachment, unknown>({
        method: "get",
        url: `/contract/parking-guide-pdf/${contractId}`,
      });
      return data;
    },
    [client]
  );

  return { findParkingGuide };
};

export default useFindParkingGuideByContractId;
